import { INavigationItem } from '../../../services/navigation-data-service/Models';

// this can be a utility function    
// Function to flatten the tree into a list of nodes
export function getFlattenedTreeData(node: INavigationItem, list: Array<INavigationItem> = []): Array<INavigationItem> {
    list.push(node);
    if (node.children) {
        node.children.forEach(child => getFlattenedTreeData(child, list));
    }
    return list;
}
